import { ACADEMIC_STATUS_MAP } from 'constants/academic-status-map';

export const ACADEMIC_STATUS_OPTIONS = [
  { label: 'Aprovado', value: 'approved' },
  { label: 'Reprovado', value: 'failed' },
  { label: 'Em andamento', value: 'in_progress' }
];

export interface AcademicStatusDisplay {
  label: string;
  dotClassName: string;
}

export const DISCIPLINE_ACADEMIC_STATUS_DISPLAY: Record<
  string,
  AcademicStatusDisplay
> = {
  approved: {
    label: ACADEMIC_STATUS_MAP.approved.label,
    dotClassName: 'bg-emerald-500'
  },
  failed: {
    label: ACADEMIC_STATUS_MAP.failed.label,
    dotClassName: 'bg-rose-500'
  },
  in_progress: {
    label: 'Em andamento',
    dotClassName: 'bg-amber-400'
  },
  attendance_failed: {
    label: ACADEMIC_STATUS_MAP.attendance_failed.label,
    dotClassName: 'bg-rose-500'
  },
  progress_failed: {
    label: ACADEMIC_STATUS_MAP.progress_failed.label,
    dotClassName: 'bg-rose-500'
  },
  exempted: {
    label: ACADEMIC_STATUS_MAP.exempted.label,
    dotClassName: 'bg-amber-400'
  },
  cancelled: {
    label: 'Cancelado',
    dotClassName: 'bg-slate-400'
  },
  inactive: {
    label: 'Inativo',
    dotClassName: 'bg-slate-400'
  }
};

export const DISCIPLINE_ACADEMIC_STATUS_OPTIONS = Object.entries(
  DISCIPLINE_ACADEMIC_STATUS_DISPLAY
).map(([value, { label }]) => ({ label, value }));

export const ENROLLMENT_TYPE_OPTIONS = [
  { label: 'Curso Livre', value: 'Courses::Enrollment' },
  { label: 'Pós-graduação', value: 'Graduate::Courses::Enrollment' }
];

export const COURSE_TYPE_OPTIONS = [
  { label: 'Curso Livre', value: 'Course' },
  { label: 'Pós-graduação', value: 'Graduate::Course' }
];

export const COURSE_PORTFOLIO_STATUS_OPTIONS = [
  { label: 'Planejado', value: 'planned' },
  { label: 'Finalizado', value: 'finished' },
  { label: 'Em andamento', value: 'in_progress' }
];
